module.exports = __webpack_public_path__ + "static/media/Cheetah.dccd5de1.png";